module.exports = __webpack_public_path__ + "static/casual-fridays-1-158270d477e2ba0050d5562f4981e08e.png";